package one.healthium.onboarding.ui.screens

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.navigationBarsPadding
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.statusBarsPadding
import androidx.compose.runtime.Composable
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import kotlinx.coroutines.launch
import one.healthium.onboarding.domain.configs.NotificationsAccessScreenConfig
import one.healthium.onboarding.ui.UserDataProvider
import one.healthium.onboarding.ui.UserProfileUiModel
import one.healthium.onboarding.ui.bindPlaceholderValues
import one.healthium.onboarding.ui.components.Notification
import one.healthium.onboarding.utils.NotificationPermissionRequester
import one.healthium.ui.components.CtaButton
import one.healthium.ui.compose.components.AppScaffold
import one.healthium.ui.compose.components.AppText
import one.healthium.ui.compose.theme.AppTheme

interface NotificationAccessEventDelegate {
    fun onNextClicked()
}

@Composable
internal fun NotificationAccessScreen(
    eventDelegate: NotificationAccessEventDelegate,
    screenConfig: NotificationsAccessScreenConfig,
) {
    UserDataProvider { userState, _ ->
        AppScaffold {
            NotificationAccessScreenContent(
                screenConfig = screenConfig,
                userState = userState,
                onNextClicked = eventDelegate::onNextClicked,
            )
        }
    }
}

@Composable
internal fun NotificationAccessScreenContent(
    modifier: Modifier = Modifier,
    screenConfig: NotificationsAccessScreenConfig,
    userState: UserProfileUiModel,
    onNextClicked: () -> Unit,
) {
    val coroutineScope = rememberCoroutineScope()

    Column(
        modifier = modifier
            .fillMaxSize()
            .statusBarsPadding()
            .navigationBarsPadding()
            .padding(horizontal = 24.dp),
        horizontalAlignment = Alignment.CenterHorizontally,
    ) {
        AppText(
            text = screenConfig.title?.bindPlaceholderValues(userState),
            style = AppTheme.textStyles.header,
            color = AppTheme.colors.text100,
            textAlign = TextAlign.Center,
        )
        Spacer(Modifier.height(12.dp))
        AppText(
            text = screenConfig.subtitle?.bindPlaceholderValues(userState),
            style = AppTheme.textStyles.subTitle,
            color = AppTheme.colors.text100,
            textAlign = TextAlign.Center,
        )
        Spacer(Modifier.weight(0.8f))
        screenConfig.notification?.let { Notification(it) }
        Spacer(Modifier.weight(1f))
        NotificationPermissionRequester { request ->
            CtaButton(
                modifier = Modifier
                    .fillMaxWidth()
                    .padding(horizontal = 14.dp),
                text = screenConfig.ctaTitle,
                onClick = {
                    coroutineScope.launch {
                        request()
                        onNextClicked()
                    }
                },
            )
        }
        Spacer(Modifier.height(24.dp))
    }
}
